import { Maybe } from '@pylot-data/fwrdschema'
import { getTrimmedUrl } from './getTrimmedUrl'
export const getFirstImage = (images: Maybe<Array<{ url: string }>>) => {
    if (images !== null) {
        if (images.length > 1) {
            return getTrimmedUrl(images[1].url)
        } else if (images.length > 0) {
            return getTrimmedUrl(images[0].url)
        }
    }
    return ''
}
